type TipTapNode = { text?: string; content?: TipTapNode[] }

export function tiptapToText(node: object | undefined): string {
  if (!node || typeof node !== 'object') return ''
  return walk(node as TipTapNode).trim()
}

function walk(node: TipTapNode): string {
  if (!node) return ''
  if (typeof node.text === 'string') return node.text
  if (Array.isArray(node.content)) return node.content.map(walk).join('')
  return ''
}
